import { FailureActionPayload } from 'store/errors/types';
import { TenantBuildingDto } from './types';
import { createAsyncAction } from 'typesafe-actions';

export const fetchTenantBuilding = createAsyncAction(
  'hqo-building/FETCH_REQUEST',
  'hqo-building/FETCH_SUCCESS',
  'hqo-building/FETCH_FAILURE',
)<string, TenantBuildingDto, FailureActionPayload>();
